(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    class MenuDrawerLocalization extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.details = this.querySelector('details');
      this.hiddenInput = this.querySelector('input[name="country_code"]');

      this.querySelectorAll('.menu-drawer__localization-option').forEach((button) => {
        button.addEventListener('click', this.onOptionSelect.bind(this));
      });
    }

    onOptionSelect(event) {
      const value = event.currentTarget.getAttribute('data-value');
      this.hiddenInput.value = value;
      this.form.submit();
    }
  }

  if (!customElements.get('menu-drawer-localization')) {
    customElements.define('menu-drawer-localization', MenuDrawerLocalization);
  }
  } catch(e) { console.error(e); }
})();

})();
